<template>
    <div class="flex flex-col gap-6 font-sans">
        <sso-config :team="props.team"></sso-config>
        <saml2-management :team="props.team"></saml2-management>
    </div>
</template>
<script setup>
import SsoConfig from './SsoConfig.vue';
import Saml2Management from './Saml2Management.vue';

const props = defineProps({
    team: {
        type: Object,
        required: true,
    },
});
</script>
